// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-item a{align-items:top;display:flex}.section-item__subtext{font-size:.875rem;font-weight:400;margin-top:.25em}.section-item img{--dim:calc(var(--menu-size)*0.8);height:calc(var(--menu-size)*.8);height:var(--dim);margin-right:.5em;margin-top:calc(var(--dim)*.3);width:calc(var(--menu-size)*.8);width:var(--dim)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
